export default __webpack_public_path__ + "static/media/logo.5fe230f7.svg";